import { useContext } from "react";
import { get } from "lodash";
import cx from "classnames";
import DatePicker from "react-datepicker";
import dateFormat from "dateformat";
import moment from "moment";
import { isPast } from "date-fns";

import { DealRoomActionPlanContext } from "../../../../context";

import styles from "./styles.module.scss";

interface DueDatePopoverProps {
  dealRoomId: string;
  stageId: string;
  actionId: string;
  isNewAction: boolean;
  dueDate: string;
  disabled: boolean;
  canEditAction: boolean;
  isActionCompleted: boolean;
  onClick: () => void;
}

const getButtonText = (dueDate: string) => {
  if (dueDate) {
    return dateFormat(dueDate, "dd mmm yyyy");
  } else {
    return "Due Date";
  }
};

const DueDatePopover = ({
  stageId,
  actionId,
  isNewAction,
  dueDate,
  disabled,
  canEditAction,
  isActionCompleted,
  onClick = () => {},
}: DueDatePopoverProps) => {
  const { state, handleEditAction } = useContext(DealRoomActionPlanContext);

  const editMode = get(state, "editMode");
  const editingItem = get(state, "editingItem");

  const buttonText = getButtonText(dueDate);
  const isOverdue = isPast(dueDate);

  const handleDueDateChange = (newDate: Date | null) => {
    const newDueDateISO = moment(newDate)
      .local()
      .endOf("day")
      .toISOString(true);

    const changes = {
      dueDate: newDueDateISO,
    };

    handleEditAction(changes, stageId, actionId, isNewAction);
  };

  return (
    <span className={styles.datePickerContainer}>
      <DatePicker
        minDate={moment().subtract(2, "years").toDate()}
        maxDate={moment().add(2, "years").toDate()}
        popperClassName={cx(styles.calendar)}
        customInput={
          <div
            className={cx(styles.actionButton, {
              [styles.overdue]: isOverdue,
              [styles.disabled]:
                !canEditAction ||
                isActionCompleted ||
                (editingItem && get(editingItem, "id") !== actionId),
            })}
          >
            <i className={cx(styles.icon, "paperflite-calendar")} />
            <p className={styles.buttonText}>{buttonText}</p>
          </div>
        }
        dateFormat="dd MMM yyyy"
        value={dueDate ? moment(dueDate).format("DD MMM YYYY") : "Pick a date"}
        onChange={handleDueDateChange}
        selected={dueDate ? moment(dueDate).toDate() : null}
        showYearDropdown
        yearDropdownItemNumber={15}
        scrollableYearDropdown
        disabled={
          disabled ||
          isActionCompleted ||
          (editMode && get(editingItem, "id") !== actionId)
        }
        popperPlacement={"left"}
        portalId={"root-portal"}
        onInputClick={onClick}
      />
    </span>
  );
};

export default DueDatePopover;
